import * as React from 'react';
import { browserVersion, isIE } from 'react-device-detect';
import { ErrorDialog } from '../error-dialog';

type UnsupportedBrowserProps = {};
type UnsupportedBrowserState = { open: boolean }

class UnsupportedBrowser extends React.Component<UnsupportedBrowserProps, UnsupportedBrowserState> {

	constructor(props: UnsupportedBrowserProps) {
		super(props);
		this.state = { open: isIE && parseInt(browserVersion) < 11 }
	}

	public handleErrorDialogClose = () => {
		this.setState({open: false});
	}

	public render(): JSX.Element {
		return this.state.open === true &&
			<ErrorDialog descriptionText={this.context.resourceProvider.getText("Error_UnsupportedBrowser_Description")} headingText={this.context.resourceProvider.getText("Error_UnsupportedBrowser_Title")} onClose={this.handleErrorDialogClose} />
	}
}

export default UnsupportedBrowser;
